import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-icorn-button-render',
  templateUrl: './icorn-button-render.component.html',
  styleUrls: ['./icorn-button-render.component.scss'] 
})
export class IcornButtonRenderComponent  implements ICellRendererAngularComp {
 
    params: any;
    getLabelFunction: any;

    agInit(params: any): void {
        this.params = params;
        this.getLabelFunction = this.params.getLabelFunction;
    }

    refresh(params?: any): boolean {
        return true;
    }
    isPopup(): boolean {
        return false;
    }
    onClick($event) {
        if (this.params.onClick instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node,
            };
            this.params.onClick(params);
        }
    }
  }
